import React, { useState } from 'react';
import { Button, Form, Input, Spin, message } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { userMangement } from '../../redux/actions/authActions';
import { BRAND_ADDED_SUCCESS } from '../../constants/messages';

function AddNewBrand(props) {
  const { onRefresh, onClose } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onFinish = (values) => {
    setLoading(true);
    dispatch(userMangement('pub.create.brand', values))
      .then(() => {
        message.success(BRAND_ADDED_SUCCESS);
        onRefresh();
        onClose();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="heading">
          <LeftOutlined
            className="back-btn"
            onClick={() => {
              onClose();
            }}
          />
          Add Brand
        </div>

        <div className="add-user-container">
          <Form
            name="basic"
            layout="vertical"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            requiredMark={false}
          >
            <div className="mt-20">
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Please input your name',
                  },
                  {
                    pattern: /^[a-zA-Z ]*$/,
                    message: 'Enter a valid alphabet',
                  },
                  {
                    min: 3,
                    message: 'Name must have minimum 3 characters',
                  },
                  {
                    max: 100,
                    message: 'Name cannot be more than 100 characters',
                  },
                ]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>
            </div>

            <div className="mt-20">
              <Form.Item
                label="Brand Name"
                name="brand_name"
                rules={[
                  {
                    required: true,
                    message: 'Please input your brand name',
                  },
                  {
                    min: 3,
                    message: 'Brand Name must be minimum 3 characters',
                  },
                ]}
              >
                <Input placeholder="Enter Brand Name" />
              </Form.Item>
            </div>

            <div className="mt-20">
              <Form.Item
                label="Email id "
                name="email"
                className="form-item"
                rules={[
                  {
                    required: true,
                    message: 'Please input your registered email!',
                  },
                  {
                    type: 'email',
                    message: 'Please Input valid email',
                  },
                ]}
              >
                <Input placeholder="Enter Email" />
              </Form.Item>
            </div>

            <div className="mt-20">
              <Form.Item
                label="Phone Number"
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: 'Please input your phone number',
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: 'Please enter a valid integer',
                  },
                  {
                    min: 10,
                    message: 'Mobile number must contain 10 digits',
                  },
                  {
                    max: 10,
                    message: 'Mobile number cannot be more than 10 digits',
                  },
                ]}
              >
                <Input placeholder="Enter Mobile No." />
              </Form.Item>
            </div>

            <div className="mt-20">
              <Form.Item>
                <Button type="primary" block htmlType="submit">
                  Create
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </Spin>
    </>
  );
}

export default AddNewBrand;
